import script from "./SubcriptionList.vue?vue&type=script&setup=true&lang=js"
export * from "./SubcriptionList.vue?vue&type=script&setup=true&lang=js"

import "./SubcriptionList.vue?vue&type=style&index=0&id=04a6d2ee&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a6d2ee"]])

export default __exports__